import { render, staticRenderFns } from "./appManage.vue?vue&type=template&id=dd6045ca&scoped=true"
import script from "./appManage.vue?vue&type=script&lang=js"
export * from "./appManage.vue?vue&type=script&lang=js"
import style0 from "./appManage.vue?vue&type=style&index=0&id=dd6045ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6045ca",
  null
  
)

export default component.exports